(function () {  
  if (!window.Shopify && !Shopify.designMode) {
    if (pathname.startsWith("/a/return-portal")) {
      window.location.assign('/apps/redo/returns-portal/login');
    }
  }
  const productJson = document.querySelector('[data-product-json]');
  if (!productJson) return;
  const product = JSON.parse(productJson.textContent);
  const variants = product.variants;
  //console.log(productJson, product, variants);
  const pathname = window.location.pathname;
  const searchParams = window.location.search;
  //console.log(pathname, searchParams);
  if (!window.Shopify && !Shopify.designMode) {
    if (pathname.startsWith("/products/") && !searchParams) {
      const preferredOptions = JSON.parse(localStorage.getItem("preferredOptions"));
      if (Array.isArray(preferredOptions)) {
        const variant = variants.find(v => v.options.toString() === preferredOptions.toString()) ||
          variants.find(v => v.options[1] === preferredOptions[1]) ||
          variants.find(v => v.options[0] === preferredOptions[0]);
        if (variant) {
          window.location.replace(`${window.location.pathname}?variant=${variant.id}`);
        }
      }
    }
  }

  function updateBidirectionalAvailability(e) {
    if (e) {
        localStorage.setItem("preferredOptions", JSON.stringify(e.detail.variant.options))
    }
    
    const optionContainers = document.querySelectorAll('variant-picker');
    optionContainers.forEach(container => {
      const selectedVariant = JSON.parse(container.querySelector('[data-variant]').textContent);
      const selections = selectedVariant.options;
      //console.log(container, selectedVariant, selections);

      const noRestock = JSON.parse(document.querySelector('[data-no-restock-json]').textContent);
      document.querySelectorAll('.klaviyo-bis-trigger').forEach(klaviyoBisButton => {
        //console.log(klaviyoBisButton);
        klaviyoBisButton.style.removeProperty('display');
        klaviyoBisButton.removeAttribute("style");
        klaviyoBisButton.classList.toggle('block', !selectedVariant.available && !noRestock);
        klaviyoBisButton.classList.toggle('hidden', selectedVariant.available || noRestock);
        //console.log(klaviyoBisButton);
      });

      container
        .querySelectorAll('input')
        .forEach(button => {
          const value = button.dataset.value;
          const isAvailable = variants.some(variant => {
            if (!variant.available) return false;

            return variant.options.every((opt, idx) => {
                const optionIndex = Number(button.dataset.optionPosition) - 1
                //console.log(opt, idx, optionIndex, value);
              if (idx === optionIndex) return opt === value;
              if (!selections[idx]) return true;
              return opt === selections[idx];
            });
          });
          const label = document.querySelector(`label[for="${button.id}"]`);
          label.classList.toggle('is-disabled', !isAvailable);
        });
    });
  }
  updateBidirectionalAvailability();
  document.addEventListener('variant:change', updateBidirectionalAvailability);
})();